'use client';

import React, { useEffect } from 'react';
import { useLanguage } from '@/lib/i18n';

export default function HtmlWrapper({ children }: { children: React.ReactNode }) {
  const { dir, language } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = dir;
  }, [language, dir]);

  return (
    <html lang="fr" dir="ltr">
      {children}
    </html>
  );
}
